import { render, staticRenderFns } from "./privacy-links.vue?vue&type=template&id=72a58315&"
import script from "./privacy-links.vue?vue&type=script&lang=js&"
export * from "./privacy-links.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports